import { Text, VStack, Box, Image } from '@chakra-ui/react';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { landing } from '../../data/landing';
interface ListProps {}

export const List: FunctionComponent<ListProps> = () => {
	return (
		<VStack>
			{landing.map((item) => (
				<Link to={'/home/' + item.title}>
					<Box textAlign='center' w='full' p={2}>
						<Box
							w='full'
							bg='#2c2c2c'
							display='flex'
							p={3}
							color='white'
							borderRadius={20}>
							<Box maxW='full'>
								<Image src={item.icon} w='100px' />
							</Box>
							<Box w='full'>
								<Text
									display={{ base: 'flex', md: 'none' }}
									fontSize='2xl'
									fontFamily='monospace'
									fontWeight='bold'
									fontStyle={{ base: 'italic', md: 'normal' }}
									paddingLeft={3}
									color='#c9c9c9'>
									{item.title}
								</Text>
								<Text
									fontSize='l'
									fontFamily='fira code'
									textAlign={'left'}
									paddingLeft={3}
									color='#afafaf'>
									{item.tagline}
								</Text>
							</Box>
						</Box>
					</Box>
				</Link>
			))}
		</VStack>
	);
};
